/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { SmppClients } from '../model/smppClients';
import { SmppClientsDto } from '../model/smppClientsDto';
import { UpdateSmppClientsDto } from '../model/updateSmppClientsDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SmppClientService {

    protected basePath = 'http://10.1.1.123:30116';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param request 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smppClientCreateSmppClient(request: SmppClientsDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public smppClientCreateSmppClient(request: SmppClientsDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public smppClientCreateSmppClient(request: SmppClientsDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public smppClientCreateSmppClient(request: SmppClientsDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling smppClientCreateSmppClient.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<string>(`${this.basePath}/api/SmppClient/CreateSmppClient`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smppClientDeleteSmppClient(id?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public smppClientDeleteSmppClient(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public smppClientDeleteSmppClient(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public smppClientDeleteSmppClient(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<string>(`${this.basePath}/api/SmppClient/DeleteSmppClient`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param aggregatorId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smppClientGetSmppClientbyAggregatorId(aggregatorId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SmppClients>>;
    public smppClientGetSmppClientbyAggregatorId(aggregatorId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SmppClients>>>;
    public smppClientGetSmppClientbyAggregatorId(aggregatorId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SmppClients>>>;
    public smppClientGetSmppClientbyAggregatorId(aggregatorId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (aggregatorId !== undefined && aggregatorId !== null) {
            queryParameters = queryParameters.set('aggregatorId', <any>aggregatorId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<SmppClients>>(`${this.basePath}/api/SmppClient/GetSmppClientbyAggregatorId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param status 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smppClientGetSmppClientbyEntityStatus(status?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<SmppClients>>;
    public smppClientGetSmppClientbyEntityStatus(status?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SmppClients>>>;
    public smppClientGetSmppClientbyEntityStatus(status?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SmppClients>>>;
    public smppClientGetSmppClientbyEntityStatus(status?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', <any>status);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<SmppClients>>(`${this.basePath}/api/SmppClient/GetSmppClientbyEntityStatus`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smppClientGetSmppClientbyId(id?: string, observe?: 'body', reportProgress?: boolean): Observable<SmppClients>;
    public smppClientGetSmppClientbyId(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmppClients>>;
    public smppClientGetSmppClientbyId(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmppClients>>;
    public smppClientGetSmppClientbyId(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SmppClients>(`${this.basePath}/api/SmppClient/GetSmppClientbyId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param systemId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smppClientGetSmppClientbySystemId(systemId?: string, observe?: 'body', reportProgress?: boolean): Observable<SmppClients>;
    public smppClientGetSmppClientbySystemId(systemId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmppClients>>;
    public smppClientGetSmppClientbySystemId(systemId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmppClients>>;
    public smppClientGetSmppClientbySystemId(systemId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (systemId !== undefined && systemId !== null) {
            queryParameters = queryParameters.set('systemId', <any>systemId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SmppClients>(`${this.basePath}/api/SmppClient/GetSmppClientbySystemId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param systemId 
     * @param password 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smppClientGetSmppClientbySystemIdAndPassword(systemId?: string, password?: string, observe?: 'body', reportProgress?: boolean): Observable<SmppClients>;
    public smppClientGetSmppClientbySystemIdAndPassword(systemId?: string, password?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmppClients>>;
    public smppClientGetSmppClientbySystemIdAndPassword(systemId?: string, password?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmppClients>>;
    public smppClientGetSmppClientbySystemIdAndPassword(systemId?: string, password?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (systemId !== undefined && systemId !== null) {
            queryParameters = queryParameters.set('systemId', <any>systemId);
        }
        if (password !== undefined && password !== null) {
            queryParameters = queryParameters.set('password', <any>password);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SmppClients>(`${this.basePath}/api/SmppClient/GetSmppClientbySystemIdAndPassword`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param request 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smppClientUpdateSmppClient(request: UpdateSmppClientsDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public smppClientUpdateSmppClient(request: UpdateSmppClientsDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public smppClientUpdateSmppClient(request: UpdateSmppClientsDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public smppClientUpdateSmppClient(request: UpdateSmppClientsDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling smppClientUpdateSmppClient.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<string>(`${this.basePath}/api/SmppClient/UpdateSmppClient`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
